




















































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EventBus } from "../event-bus";
import ConfirmationModal from "./ConfirmationModal.vue";
import axios from "axios";
import { Token } from "../utils/Token";

@Component({
  components: {
    ConfirmationModal,
  },
})
export default class CreateFileUser extends Vue {
  @Prop() readonly value!: boolean;

  public user :any={
    firstName: "",
    lastName: "",
    username: "",
    password: "",
    email:"",
    status:100,
    type:1,
    };
    //mode is for initial button pressed. If true means the create button pressed. if false means the search button pressed.
    //searchmode is for choosing user. if false means show table to choose user. If true means 'user chosen' so show the create screen but with user data for edit mode.
    //if there  was no searchmode then we couldn't change title and hide password/switch/delete .
  private mode=true;
  private searchmode=true;
  private search="";
  private passwordCheck="";
  private show1=false;
  private show2=false;
  private nameRules: any = [];
  private emailRules:any=[];
  private passRules: any = [];
  private pass2Rules: any = [];
  private items: Array<any> = [];
  public headers = [
    {
      text: "Username",
      value: "username",
      sortable: true,
      align: "start",
    },
    {
      text: "First Name",
      align: "start",
      value: "firstName",
      sortable: true,
    },
    {
      text: "Last Name",
      value: "lastName",
      sortable: true,
      align: "start",
    },
    {
      text: "Email",
      value: "email",
      sortable: false,
      align: "center",
    },{
      text: "Account Status",
      value: "status",
      sortable: true,
      align: "center",
    },
    {
      text: "Account Type",
      value: "type",
      sortable: true,
      align: "center",
    },
    { 
      text: "Actions", 
      value: "actions", 
      sortable: false, 
      align: "center" 
    },
  ];
 

  get show() {
    return this.value;
  }

  set show(value: boolean) {
    EventBus.$emit("closeCreateFileUserModal", value);
  }

  created() {
    EventBus.$on("openFileUserModal",(mode:boolean)=>{
      this.mode=mode;
      this.searchmode=mode;
      if (!this.searchmode){
        this.getUsers();
      }
    });

  }

  beforeDestroy () {
      EventBus.$off('closeCreateFileUserModal')
  }
  @Watch("user.firstName")
  @Watch("user.lastName")
  firstNameChanged() {
    this.nameRules = [];
  }

  @Watch("user.email")
  emailChanged() {
    this.emailRules = [];
  }

  
  @Watch("user.password")
  @Watch("passwordCheck")
  passChanged() {
    this.passRules = [];  
    this.pass2Rules = [];  
  }

  private createRules():void{
    this.editRules();
    this.passRules = [
      (v: any) => !!v || "Password is required",
      (v: any) => /^(?=.*?[A-Za-z])(?=.*?\d)(?=.*?[@$!%*#?&]).{8,}$/.test(v) || "Password must be at least 8 chars and must contain a letter, a number and a symbol.",
    ];
    //first ? asks at least one letter. second ? asks at least one digit. third ? asks any symbol.
      
    this.pass2Rules = [
      (v: any) => !!v || "Password is required",
      (v: any) => /^(?=.*?[A-Za-z])(?=.*?\d)(?=.*?[@$!%*#?&]).{8,}$/.test(v) || "Password must be at least 8 chars and must contain a letter, a number and a symbol.",
      () => {
        if (this.user.password === this.passwordCheck) {
          return true;
        } else {
          return 'Passwords do not match.';
        }},    
      ];
  }

  private editRules():void{
    this.nameRules = [
      (v: any) => !!v || "Name is required",
      (v: any) =>
        /^[a-zA-Z0-9]+$/.test(v) || "Name must contain only letters or numbers",
    ];

    this.emailRules=[
      (v: any) => !!v || "Email is required",
      (v: any) =>
        /^\w+([.-_]\w+)*@\w+([.-_]\w+)*(\.[a-zA-Z]{2,5})+$/.test(v) || "invalid email",
    ];
    //accepted:
    //aaa9.9-k_o@y8.comp.edu.com    ang.sfyr@gmail.com    ang_sftr@yahoo.gr   tei@uniwa.edu.gr    teia.l@unima.gpr

  }
  private submitHandler(): void {
    this.mode?this.createRules:this.editRules;

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    setTimeout(function () {
      // In order for TypeScript to know which type is being used for form, we need to cast the value.
      const result = (
        self.$refs.form as Vue & {
          validate: () => boolean;
        }
      ).validate();
      console.log("result of validation:", result);
      
      if (result) {
        //mode:create 
        if (self.mode){
            self.CreateFunction();
        }else{
        //!mode:edit
            self.UpdateFunction();
        }
      } else {
        console.log("failed validation");
      }
    });
  }

  private async CreateFunction(){
    const token = await Token.getTokenWithExpiry("token");
    const user ={
    firstName: this.user.firstName,
    lastName:this.user.lastName,
    username: this.user.username,
    password: this.user.password,
    email:this.user.email,
    type:1,
    };

    await axios({
      method: "post",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/adminAccount`,
      data: user,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   
        let flag=false;
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            flag=true;
          }
          const snackbarData = {
          text:
            flag === true
              ? "The user has been created."
              : "Error: The user was not created.",
          color: flag === true ? "#4caf50" : "#2196f3",
          };
          if(response.data.code == 409){
            snackbarData.text.concat(" Username already exists.")
          }
          EventBus.$emit("showSnackbar", snackbarData);
          this.cancel();
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   
        console.log("error:", err);
      });


  }

  private async UpdateFunction(){
    const token = await Token.getTokenWithExpiry("token");

    const user ={
    firstName: this.user.firstName,
    lastName:this.user.lastName,
    username: this.user.username,
    email:this.user.email,
    status:this.user.status,
    id:this.user.id,
    };
      axios({
        method: "put",
        url: `${process.env.VUE_APP_BASE_URL}/adminAccount/${user.id}`,
        data: user,
        withCredentials: true,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => { 
          if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          let flag=false;;
          if (response.data.code == 200) {
            flag=true;
          }
          const snackbarData = {
          text:
            flag === true
              ? "The user has been updated."
              : "Error: The user was not updated.",
          color: flag === true ? "#4caf50" : "#2196f3",
          };
          EventBus.$emit("showSnackbar", snackbarData);
          this.cancel();
        }
        })
        .catch((err) => {
          console.log("failed edit API call:", err);
        });
  }

  // close modal and clear input fields
  private cancel(): void {
    this.show = false;
    this.user = {
        firstName: "",
        lastName: "",
        username: "",
        password: "",
        email:"",
        status:100,
        type:1,
      };
  }

  private async DeleteUser(){
    const token = await Token.getTokenWithExpiry("token");
    const id=this.user.id;
    //EventBus.$emit("BeginLoader",null );   

    await axios({
      method: "delete",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/adminAccount/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          let flag=false;
          if (response.data.code == 200) {
            if (response.data.code == 200) {
            flag=true;
          }
          const snackbarData = {
          text:
            flag === true
              ? "The user has been deleted."
              : "Error: The user was not deleted.",
          color: flag === true ? "#4caf50" : "#2196f3",
          };
          EventBus.$emit("showSnackbar", snackbarData);
          this.cancel();
        }
      }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   
        console.log("error:", err);
      });
  }

  private async SearchUser(){
    const token = await Token.getTokenWithExpiry("token");
    const queryString=this.search;
    //EventBus.$emit("BeginLoader",null );

    await axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/adminAccount/${queryString}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        //EventBus.$emit("FinishLoader",null );   

        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          if (response.data.code == 200) {
            this.items = response.data.results.filter(
              (e: {id:number,firstName: string,lastName:string,username: string, email:string,type:number, status:number})=>
              e.type==1)
            if (this.items.length>0){
              this.user=this.items[0];
              this.searchmode=!this.searchmode;            
            }else{
              const snackbarData = {
              text:"Error: No user found.",
              color: "#2196f3",
              };
              EventBus.$emit("showSnackbar", snackbarData);
            }
            //TODO more than one
            console.log("target:",this.user);
          }
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );   
        console.log("error:", err);
      });

  }

  private async getUsers(){
    console.log("Fetching Users");

    const token = await Token.getTokenWithExpiry("token");
    //console.log("token:", token);

    await axios({
      method: "get",
      withCredentials: true,
      url: `${process.env.VUE_APP_BASE_URL}/adminAccount`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.code == 401) {
          EventBus.$emit("LogOutEventBus", false);
        } else {
          console.log("response:", response);
          if (response.data.code == 200) {
            this.items = [];
            this.items = response.data.results;
          }
        }
      })
      .catch((err) => {
        //EventBus.$emit("FinishLoader",null );
        console.log(err);
      });
  }
}

